import { clsx } from 'clsx';
import type { HTMLAttributes, ReactNode } from 'react';

type EyebrowTone = 'gold' | 'champagne' | 'parchment';

type EyebrowProps = {
  tone?: EyebrowTone;
  children: ReactNode;
} & Omit<HTMLAttributes<HTMLParagraphElement>, 'children'>;

const TONE_CLASSES: Record<EyebrowTone, string> = {
  gold: 'text-gold',
  champagne: 'text-champagne',
  parchment: 'text-parchment',
};

export function Eyebrow({ tone = 'champagne', className, children, ...rest }: EyebrowProps) {
  return (
    <p
      className={clsx(
        'font-mono text-xs uppercase tracking-stamp',
        TONE_CLASSES[tone],
        className,
      )}
      {...rest}
    >
      {children}
    </p>
  );
}
